import * as Api from './report.api'
import * as queryUtil from './query'
import * as way from './way'
import * as classCharts from '../components/common/chart/style_charts'
const log = console.log.bind(console)
// 获取指标
const getIndex = (a, params) => {
    let b = null
    b = a
    b.loading.indexLoading = true
    Api.getTarget(params)
        .then((res) => {
            b.loading.indexLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.summaryList = res.data.data
            }
        })
        .catch(() => {})
}
// 获取新指标
const getIndexTwo = (a, params) => {
    let b = null
    b = a
    b.loading.indexLoading = true
    Api.getTargetTwo(params)
        .then((res) => {
            b.loading.indexLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.summaryList = res.data.data
            }
        })
        .catch(() => {})
}
// 分析饼图+趋势的饼图
const getPie = (a, params) => {
    let b = null
    b = a
    if (!b.queryCommon.compareType) {
        b.loading.pieLoading1 = true
    } else {
        b.weekShow = false
        b.loading.pieLoading2 = true
        b.loading.pieLoading3 = true
    }
    Api.getPie(params)
        .then((res) => {
            if (b.queryCommon.compareType) {
                console.log('饼图')
                // 对比，双饼图
                b.loading.pieLoading2 = false
                b.loading.pieLoading3 = false
                if (res.data && res.data.errorCode === 0 && res.data.data) {
                    let pie1 = queryUtil.setPieSerise(res.data.data[0].data)
                    let pie2 = queryUtil.setPieSerise(res.data.data[1].data)
                    b.twoPieName[0] = res.data.data[0].name
                    b.twoPieName[1] = res.data.data[1].name
                    b.option3 = Object.assign(
                        {},
                        b.option3,
                        classCharts.chartPie(pie1)
                    )
                    b.option4 = Object.assign(
                        {},
                        b.option4,
                        classCharts.chartPie(pie2)
                    )
                }
            } else {
                console.log('饼图二')
                console.log(res.data.data[0].data)
                b.loading.pieLoading1 = false
                if (res.data && res.data.errorCode === 0 && res.data.data) {
                    let pie = queryUtil.setPieSerise(res.data.data[0].data)
                    b.option1 = Object.assign(
                        {},
                        b.option1,
                        classCharts.chartPieTrend(pie)
                    )
                }
            }
        })
        .catch(() => {})
}
// 分析饼图+趋势的饼图
const getPieTwo = (a, params) => {
    let b = null
    b = a
    if (!b.queryCommon.compareType) {
        b.loading.pieLoading1 = true
    } else {
        b.weekShow = false
        b.loading.pieLoading2 = true
        b.loading.pieLoading3 = true
    }
    Api.getPieTwo(params)
        .then((res) => {
            if (b.queryCommon.compareType) {
                // 对比，双饼图
                b.loading.pieLoading2 = false
                b.loading.pieLoading3 = false
                if (res.data && res.data.errorCode === 0 && res.data.data) {
                    let pie1 = queryUtil.setPieSerise(res.data.data[0].data)
                    let pie2 = queryUtil.setPieSerise(res.data.data[1].data)
                    b.twoPieName[0] = res.data.data[0].name
                    b.twoPieName[1] = res.data.data[1].name
                    b.option3 = Object.assign(
                        {},
                        b.option3,
                        classCharts.chartPie(pie1)
                    )
                    b.option4 = Object.assign(
                        {},
                        b.option4,
                        classCharts.chartPie(pie2)
                    )
                }
            } else {
                b.loading.pieLoading1 = false
                if (res.data && res.data.errorCode === 0 && res.data.data) {
                    let pie = queryUtil.setPieSerise(res.data.data[0].data)
                    b.option1 = Object.assign(
                        {},
                        b.option1,
                        classCharts.chartPieTrend(pie)
                    )
                }
            }
        })
        .catch(() => {})
}
// 饼图下钻,第一个图，或者饼图对比
const getOnePie = (a, params) => {
    console.log(1)
    let b = null
    b = a
    if (!b.queryCommon.compareType) {
        b.loading.pieLoading1 = true
    } else {
        params.categoryID = ''
        params.timeLength = ''
        b.loading.pieLoading2 = true
        b.loading.pieLoading3 = true
    }
    Api.getTwoPie(params)
        .then((res) => {
            if (b.queryCommon.compareType) {
                b.loading.pieLoading2 = false
                b.loading.pieLoading3 = false
                if (res.data && res.data.errorCode === 0 && res.data.data) {
                    let pie1 = queryUtil.setPieSerise(res.data.data[0].data)
                    let pie2 = queryUtil.setPieSerise(res.data.data[1].data)
                    b.option3 = Object.assign(
                        {},
                        b.option3,
                        classCharts.chartPie(pie1)
                    )
                    b.option4 = Object.assign(
                        {},
                        b.option4,
                        classCharts.chartPie(pie2)
                    )
                }
            } else {
                b.loading.pieLoading1 = false
                if (res.data && res.data.errorCode === 0 && res.data.data) {
                    b.pie1Data = res.data.data[0].data
                    let pie = queryUtil.setPieSerise(res.data.data[0].data)
                    b.option1 = Object.assign(
                        {},
                        b.option1,
                        classCharts.chartPie(pie)
                    )
                }
            }
        })
        .catch(() => {})
}
// 第二版吧。饼图下钻,第一个图，或者饼图对比
const getOnePieTwo = (a, params) => {
    let b = null
    b = a
    if (!b.queryCommon.compareType) {
        b.loading.pieLoading1 = true
    } else {
        params.categoryID = ''
        params.timeLength = ''
        b.loading.pieLoading2 = true
        b.loading.pieLoading3 = true
    }
    Api.getTwoPieTwo(params)
        .then((res) => {
            if (b.queryCommon.compareType) {
                b.loading.pieLoading2 = false
                b.loading.pieLoading3 = false
                if (res.data && res.data.errorCode === 0 && res.data.data) {
                    let pie1 = queryUtil.setPieSerise(res.data.data[0].data)
                    let pie2 = queryUtil.setPieSerise(res.data.data[1].data)
                    b.option3 = Object.assign(
                        {},
                        b.option3,
                        classCharts.chartPie(pie1)
                    )
                    b.option4 = Object.assign(
                        {},
                        b.option4,
                        classCharts.chartPie(pie2)
                    )
                }
            } else {
                b.loading.pieLoading1 = false
                if (res.data && res.data.errorCode === 0 && res.data.data) {
                    b.pie1Data = res.data.data[0].data
                    let pie = queryUtil.setPieSerise(res.data.data[0].data)
                    b.option1 = Object.assign(
                        {},
                        b.option1,
                        classCharts.chartPie(pie)
                    )
                }
            }
        })
        .catch(() => {})
}
// 饼图下钻，第二个图
const getDeepPie = (a, params) => {
    console.log(2)
    let b = null
    b = a
    b.loading.chartLoading1 = true
    Api.getTwoPie(params)
        .then((res) => {
            b.loading.chartLoading1 = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let pie = queryUtil.setPieSerise(res.data.data[0].data)
                b.option2 = Object.assign(
                    {},
                    b.option2,
                    classCharts.chartPie2(pie, {
                        width: 560,
                        height: 260,
                        type: 'pie',
                    })
                )
            } else {
                b.option2 = Object.assign(
                    {},
                    b.option2,
                    classCharts.chartPie([])
                )
            }
        })
        .catch(() => {})
}
// 第二版本。饼图下钻，第二个图
const getDeepPieTwo = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading1 = true
    Api.getTwoPieTwo(params)
        .then((res) => {
            b.loading.chartLoading1 = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let pie = queryUtil.setPieSerise(res.data.data[0].data)
                b.option2 = Object.assign(
                    {},
                    b.option2,
                    classCharts.chartPie2(pie, {
                        width: 560,
                        height: 260,
                        type: 'pie',
                    })
                )
            } else {
                b.option2 = Object.assign(
                    {},
                    b.option2,
                    classCharts.chartPie([])
                )
            }
        })
        .catch(() => {})
}
// 一个图，热力图
const getHeatmap = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getHeatmaps(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let flag = false
                res.data.data.forEach((item) => {
                    item.forEach((ele) => {
                        if (ele < 0) {
                            flag = true
                        }
                    })
                })
                // 如果数组有负数
                if (flag) {
                    b.option5 = Object.assign(
                        {},
                        b.option5,
                        classCharts.heatchart(
                            res.data.data,
                            b.page.xname,
                            b.page.chartTitle,
                            {
                                maxColor: '#FF5657',
                                minColor: '#2CC66D',
                            }
                        )
                    )
                } else {
                    // 没有负数
                    b.option5 = Object.assign(
                        {},
                        b.option5,
                        classCharts.heatchart(
                            res.data.data,
                            b.page.xname,
                            b.page.chartTitle
                        )
                    )
                }
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.heatchart([])
                )
            }
        })
        .catch((err) => {})
}
// 一个图，桑基图
const getSangkey = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getSangkey(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let spliner = queryUtil.setSangKey(res)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartSangKeyTrend(spliner, b.page.xname)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartSangKeyTrend([])
                )
            }
        })
        .catch((err) => {})
}
// 一个图，漏斗图
const getFunnel = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getFunnel(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let spliner = queryUtil.setFunnel(res)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartFunnel(spliner, b.page.xname)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartFunnel([])
                )
            }
        })
        .catch((err) => {})
}
// 2个图，饼图+趋势的趋势图
const getTwoTrend = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading1 = true
    Api.getTrend(params)
        .then((res) => {
            b.loading.chartLoading1 = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let spliner = queryUtil.setTrendSerise(res.data.data, true)
                b.option2 = Object.assign(
                    {},
                    b.option2,
                    classCharts.chartSplineTrend(spliner)
                )
            } else {
                b.option2 = Object.assign(
                    {},
                    b.option2,
                    classCharts.chartSplineTrend({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 两个图，一个漏斗图一个趋势图
const getFunnelTwoTrend = (a, params) => {
    if(params.constantKey === 'wxbook_transfer_funnel_dimension'){
        params.bookSource = 2
    }else if(params.constantKey === "telphonebook_transfer_funnel_dimension"){
        params.bookSource = 0
    }
    let b = null
    b = a
    // b.loading.chartLoading = true
    // const param = {"indicatorIDs":[206],"startTime":"2023-04-04","endTime":"2023-05-03","customerType":-1,"isOld":-1,"compareType":0,"constantKey":"coupon_secondary_transfer_funnel_dimension","constantType":2,"identityType":3,"discountType":2,"discountID":138,"byWhichWay":""}
    // console.log(param)
    Api.getFunnel(params)
        .then((res) => {
            console.log(res)
            b.loading.chartLoading = false
            // const res = {data:{"errorCode":0,"errorMsg":"成功","data":{"data":[["领取优惠券人数",1091],["使用优惠券人数",38],["二次到店消费人数",2]],"name":"优惠券人数"}}}
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let spliner = queryUtil.setFunnel(res)
                spliner.width = 600
                spliner.height = 350
                b.option1 = Object.assign(
                    {},
                    b.option1,
                    classCharts.chartFunnel(spliner, b.page.xname)
                )
            } else {
                b.option1 = Object.assign(
                    {},
                    b.option1,
                    classCharts.chartFunnel([])
                )
            }
        })
        .catch((err) => {
            console.log('漏斗图失败' ,err)
        })
}
// 一个图，趋势图，未区分之前
const getTrend = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrend(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let spliner = queryUtil.setTrendSerise(res.data.data, true)
                // 对比
                if (b.queryCommon.compareType) {
                    b.option5 = Object.assign(
                        {},
                        b.option5,
                        classCharts.chartContrastSpline(
                            spliner,
                            b.queryCommon.compareType
                        )
                    )
                } else {
                    b.option5 = Object.assign(
                        {},
                        b.option5,
                        classCharts.chartSpline(spliner)
                    )
                }
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartSpline({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 趋势图，区分后，正常
const getTrendOne = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrendOne(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let spliner = queryUtil.setTrendSerise(res.data.data, true)
                // 对比
                if (b.queryCommon.compareType) {
                    b.option5 = Object.assign(
                        {},
                        b.option5,
                        classCharts.chartContrastSpline(
                            spliner,
                            b.queryCommon.compareType
                        )
                    )
                } else {
                    b.option5 = Object.assign(
                        {},
                        b.option5,
                        classCharts.chartSpline(spliner)
                    )
                }
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartSpline({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 趋势图，区分后，多维度
const getTrendTwo = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrendTwo(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let spliner = queryUtil.setTrendSerise(res.data.data, true)
                // 对比
                if (b.queryCommon.compareType) {
                    b.option5 = Object.assign(
                        {},
                        b.option5,
                        classCharts.chartContrastSpline(
                            spliner,
                            b.queryCommon.compareType
                        )
                    )
                } else {
                    b.option5 = Object.assign(
                        {},
                        b.option5,
                        classCharts.chartSpline(spliner)
                    )
                }
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartSpline({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 趋势图，区分后，同比环比基准
const getTrendThird = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrendThird(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let column = queryUtil.setTrendSerise(res.data.data)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn(column)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 柱状图，未排序(区分前)
const getCloumn = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrend(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let column = queryUtil.setTrendSerise(res.data.data)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn(column)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
const getWordCloud = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    params.type = 1
    Api.getWordCloud(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let data = {
                    series: [
                        {
                            type: 'wordcloud',
                            data: res.data.data.wordCloudText,
                        },
                    ],
                    util: { 订单评价内容分析: '' },
                }
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.wordCloudChart(data)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.wordCloudChart({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
const getTreeChart = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    params.type = 1
    Api.getWordCloud(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let d = res.data.data.wordCloudText
                d.forEach((v) => (v.colorValue = v.value))

                let data = {
                    series: [{ type: 'treemap', data: d }],
                    util: { 评价标签分析: '' },
                    colorAxis: {
                        minColor: '#FFFFFF',
                        maxColor: '#7550cd',
                    },
                }
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.treeChart(data)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.treeChart({ series: [] })
                )
            }
        })
        .catch((err) => {
            console.error(err)
        })
}
// 柱状图，排序，区分前
const getSortCloumn = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrend(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let a = res.data.data
                let data = way.sortTwoData(a)
                let column = queryUtil.setTrendSerise(data)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn(column)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 柱状图，区分后，正常
const getCloumnOne = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrendOne(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let column = queryUtil.setTrendSerise(res.data.data)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn(column)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 柱状图，区分后，排序
const getSortCloumnOne = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrendOne(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let a = res.data.data
                let data = way.sortTwoData(a)
                let column = queryUtil.setTrendSerise(data)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn(column)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 柱状图，区分后，去除数据为0的，排序.优惠券详情，使用项目去除数据为0的
const getSortCloumnThree = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrendOne(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let a = res.data.data
                let arr = []
                a.yaxislist[0].value.forEach((item, i) => {
                    if (item !== 0) {
                        arr.push(i)
                    }
                })
                a.xaxis = a.xaxis.filter((ele, j) => {
                    if (arr.includes(j)) return ele
                })
                a.yaxislist[0].value = a.yaxislist[0].value.filter((ele, j) => {
                    if (arr.includes(j)) return ele
                })
                let data = way.sortTwoData(a)
                let column = queryUtil.setTrendSerise(data)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn(column)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 柱状图，区分后，多维度
const getCloumnTwo = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrendTwo(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let column = queryUtil.setTrendSerise(res.data.data)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn(column)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
// 柱状图，区分后，同比环比基准
const getCloumnThird = (a, params) => {
    let b = null
    b = a
    b.loading.chartLoading = true
    Api.getTrendThird(params)
        .then((res) => {
            b.loading.chartLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                let column = queryUtil.setTrendSerise(res.data.data)
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn(column)
                )
            } else {
                b.option5 = Object.assign(
                    {},
                    b.option5,
                    classCharts.chartColumn({ series: [] })
                )
            }
        })
        .catch((err) => {})
}
const getOneTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataToTableCommon(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
const getOneTableTwo = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableTwo(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataToTableCommon(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
                console.log('bbbbb',b.tableInfo)
            }
        })
        .catch((err) => {})
}
const getNoDimensionTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getNoDimensionTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataTonoDemesion(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
// 一行表头，自定义维度,客流分析
const getTableCard = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTable(params)
        .then((res) => {
            console.log(res)
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiNormalToTable(res)
                )
            }
        })
        .catch((err) => {})
}
// 一行表头，自定义维度,客流分析
const getTableCardTwo = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableTwo(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiNormalToTable(res)
                )
            }
        })
        .catch((err) => {})
}
const getOneLevel = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiCompareToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
const getOneLevelTwo = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableTwo(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiCompareToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
const getColorTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableOne(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                // const last = res.data.data.tableData.data
                // b.currentTotal = last[last.length - 1]
                // last.pop()
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}

const getColorTables = (a, params) => {
    const log = console.log.bind(console)
    let b = null
    b = a
    b.loading.tableLoading = true
    // params.sortIndex -= 1
    let i = params.sortIndex
    log(`-------SORT INDEX IS (${i})-------`)
    Api.getTableOnes(params)
        .then((res) => {
            // params.sortIndex += 1
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                // const last = res.data.data.tableData.data
                // b.currentTotal = last[last.length - 1]
                // last.pop()
                // log('params.sortIndex', params.sortIndex)
                let q = queryUtil.setApiDataToTable(
                    res,
                    params.ascending,
                    params.sortIndex,
                    b.page.tableTitle
                )
                // log(q)
                b.tableInfo = Object.assign({}, b.tableInfo, q)
            }
        })
        .catch((err) => {})
}

const getColorTableTwo = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableOne(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                let q = queryUtil.setApiDataToTable(
                    res,
                    params.ascending,
                    params.sortIndex,
                    b.page.tableTitle
                )
                // log(q)
                b.tableInfo = Object.assign({}, b.tableInfo, q)
            }
        })
        .catch(() => {})
}

const getContastTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiCompareToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
const getContastTableTwo = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableThird(params)
        .then((res) => {
            // console.log(res);
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiCompareToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
                // console.log(b.tableInfo);
            }
        })
        .catch((err) => {})
}
const getContastTableThird = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableTwo(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiCompareToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
const getAreaTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getAreaTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
const getAreaTableTwo = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getAreaTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
const getDateTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    const log = console.log.bind(console)
    log('get date table', params)
    Api.getTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = {}
                // 对比
                if (b.queryCommon.compareType) {
                    b.tableInfo = Object.assign(
                        {},
                        b.tableInfo,
                        queryUtil.setApiCompareToTable(
                            res,
                            params.ascending,
                            params.sortIndex,
                            b.page.tableTitle
                        )
                    )
                } else {
                    b.tableInfo = Object.assign(
                        {},
                        b.tableInfo,
                        queryUtil.setApiDataToTableCommon(
                            res,
                            params.ascending,
                            params.sortIndex,
                            b.page.tableTitle
                        )
                    )
                }
            }
        })
        .catch((err) => {})
}
const getDateTableTwo = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableTwo(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = {}
                // 对比
                console.log("对比shuju ：b.queryCommon.compareType",b.queryCommon.compareType)
                if (b.queryCommon.compareType) {
                    b.tableInfo = Object.assign(
                        {},
                        b.tableInfo,
                        queryUtil.setApiCompareToTable(
                            res,
                            params.ascending,
                            params.sortIndex,
                            b.page.tableTitle
                        )
                    )
                } else {
                    b.tableInfo = Object.assign(
                        {},
                        b.tableInfo,
                        queryUtil.setApiDataToTableCommon(
                            res,
                            params.ascending,
                            params.sortIndex,
                            b.page.tableTitle
                        )
                    )
                    console.log(12313,b.tableInfo)
                }
            }
        })
        .catch((err) => {})
}
const getDateTableThree = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    // LE-3347 目标导入失败，历史的目标都是0
    // timelyType  1 月度， 2季度，3年度
    console.log('params', params)
    if (params.identifyKey === 'monthly_target_manage') {
        if (params.startTime.length === 10) {
            // 包含日， 把日去掉
            params.startTime = params.startTime.substring(0, 7)
        }
        if (params.endTime.length === 10) {
            // 包含日， 把日去掉
            params.endTime = params.endTime.substring(0, 7)
        }
    } else if (params.identifyKey === 'yearly_target_manage') {
        if (params.month.length === 4) {
            params.startTime = params.month + '-01'
            params.endTime = params.month + '-12'
        }
    } else {
        //
    }
    Api.getTableThree(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = {}
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataToTableCommon(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
// 项目的一级图表
const getAnalysisTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTable(params)
        .then((res) => {
            // log(JSON.stringify(res, null, 4) )
            b.loading.tableLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
const getAnalysisTableTwo = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getTableTwo(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = Object.assign(
                    {},
                    b.tableInfo,
                    queryUtil.setApiDataToTable(
                        res,
                        params.ascending,
                        params.sortIndex,
                        b.page.tableTitle
                    )
                )
            }
        })
        .catch((err) => {})
}
// 项目的二级图表
const getAnalysisTwo = (a, params, index) => {
    let b = null
    b = a
    Api.getTwoTable(params)
        .then((res) => {
            b.loading.chartLoading.splice(index, 1, false)
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.interSort(res.data.data, index)
            } else {
                b.addList[index].push(['无数据', ''])
            }
        })
        .catch((err) => {})
}
// 项目的二级图表
const getAnalysisTwoTwo = (a, params, index) => {
    let b = null
    b = a
    Api.getTwoTableTwo(params)
        .then((res) => {
            b.loading.chartLoading.splice(index, 1, false)
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.interSort(res.data.data, index)
            } else {
                b.addList[index].push(['无数据', ''])
            }
        })
        .catch((err) => {})
}

const getRetainTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getRetainTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data && res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = {}
                const wt = res.data.data
                wt.tableData.data.forEach((item, count) => {
                    item['userNum'] = item.noCompareData[0]
                    item.noCompareData.shift()
                    item['scale'] = []
                    item.noCompareData.forEach((m, index) => {
                        if (item['userNum'] === 0) {
                            item['scale'].push('0%')
                        } else {
                            // 数
                            // if (params.indicatorID === 129) {
                            //   item['scale'].push(parseFloat(((item.data[index] / item['userNum']) * 100).toFixed(1)) + '%')
                            // } else {
                            //   // 率
                            //   item['scale'].push(m)
                            // }
                            // 数
                            if (typeof m === 'number') {
                                item['scale'].push(
                                    parseFloat(
                                        (
                                            (item.noCompareData[index] /
                                                item['userNum']) *
                                            100
                                        ).toFixed(1)
                                    ) + '%'
                                )
                            } else {
                                // 率
                                item['scale'].push(m)
                            }
                        }
                    })
                })
                b.tableInfo = Object.assign({}, self.tableInfo, wt, {
                    title: b.page.chartTitle,
                    byWhichWay: params.byWhichWay,
                    name: b.page.xname,
                })
            } else {
                b.tableInfo = { noData: true }
            }
        })
        .catch((err) => {})
}
const getNoRechargeTable = (a, params) => {
    let b = null
    b = a
    b.loading.tableLoading = true
    Api.getNoRechargeTable(params)
        .then((res) => {
            b.loading.tableLoading = false
            if (res.data.errorCode === 0 && res.data.data) {
                b.tableInfo = res.data.data
            } else {
                // 接口请求失败了, 要做处理，不然页面数据不变
                b.tableInfo = {}
                // b.tableInfo = {
                //     count: 1, list: [], pageNum: 1, pagecount: 1, size: 20
                // }
            }
        })
        .catch((err) => {})
}

export {
    getIndex,
    getIndexTwo,
    getPie,
    getTrend,
    getTrendOne,
    getTrendTwo,
    getTrendThird,
    getCloumn,
    getCloumnOne,
    getCloumnTwo,
    getCloumnThird,
    getOneTable,
    getOneTableTwo,
    getColorTable,
    getColorTables,
    getColorTableTwo,
    getContastTable,
    getContastTableTwo,
    getDateTable,
    getDateTableTwo,
    getOnePie,
    getOneLevel,
    getOneLevelTwo,
    getTwoTrend,
    getTableCard,
    getHeatmap,
    getAreaTable,
    getDeepPie,
    getAnalysisTable,
    getAnalysisTwo,
    getSangkey,
    getSortCloumn,
    getRetainTable,
    getFunnel,
    getTableCardTwo,
    getAreaTableTwo,
    getAnalysisTableTwo,
    getSortCloumnOne,
    getContastTableThird,
    getOnePieTwo,
    getDeepPieTwo,
    getPieTwo,
    getAnalysisTwoTwo,
    getNoDimensionTable,
    getSortCloumnThree,
    getDateTableThree,
    getNoRechargeTable,
    getWordCloud,
    getTreeChart,
    getFunnelTwoTrend
}
